import React from 'react';
import { aboutText } from './about-text';
import './HomeText.css';

function HomeText() {
  return (
    <div className="home-text">
      <div className="home-text-content">
        <h2 className="home-text-title"><span className="gradient-word">Earn More</span> from the Music You Already Released.</h2>
        <div className="gradient-divider"></div>
        {aboutText.split('\n\n').map((paragraph, index) => (
          <p key={index} className="home-text-paragraph">
            {paragraph.trim()}
          </p>
        ))}
      </div>
    </div>
  );
}

export default HomeText; 